import { render } from "./media.vue?vue&type=template&id=37dfa47a"
import script from "./media.vue?vue&type=script&lang=js"
export * from "./media.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/appitoc/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__